import Login from "views/login/Login.jsx";
import strings from "./core/translate";
import ApplicationSetup from "./views/app-settings/ApplicationSetup";
import CityList from "./views/city/CityList";
import CityAddUpdate from "./views/city/CityAddUpdate";
import BannerAddUpdate from "./views/banner/BannerAddUpdate";
import BannerList from "./views/banner/BannerList";
import UserList from "./views/user/UserList";
import UserAddUpdate from "./views/user/UserAddUpdate";
import MerchantAddUpdate from "./views/merchants/MerchantAddUpdate";
import MerchantList from "./views/merchants/MerchantList";
import VehicleMakeList from "./views/vehicles-make/VehicleMakeList";
import VehicleMakeAddUpdate from "./views/vehicles-make/VehicleMakeAddUpdate";
import NotificationList from "./views/notifications/NotificationList";
import NotificationAddUpdate from "./views/notifications/NotificationAddUpdate";
import ServiceList from "./views/services/ServiceList";
import ServiceAddUpdate from "./views/services/ServiceAddUpdate";
import VehicleModelList from "./views/vehicles-models/VehicleModelList";
import VehicleModelAddUpdate from "./views/vehicles-models/VehicleModelAddUpdate";
import VehicleModelTrimsList from "./views/vehicles-models-trims/VehicleModelTrimsList";
import VehicleModelTrimsAddUpdate from "./views/vehicles-models-trims/VehicleModelTrimsAddUpdate";
import MerchantBranchServiceList from "./views/merchants-branches-services/MerchantBranchServiceList";
import MerchantBranchServiceAddUpdate from "./views/merchants-branches-services/MerchantBranchServiceAddUpdate";
import CustomerVehiclesList from "./views/customer-vehicles/CustomerVehiclesList";
import CustomerVehiclesAddUpdate from "./views/customer-vehicles/CustomerVehiclesAddUpdate";
import CustomerUserAddUpdate from "./views/customer-user/CustomerUserAddUpdate";
import CustomerUserList from "./views/customer-user/CustomerUserList";
import MerchantBranchAppointmentSettingsList from "./views/merchant-branch-appointments-settings/MerchantBranchAppointmentSettingsList";
import MerchantBranchAppointmentSettingsAddUpdate from "./views/merchant-branch-appointments-settings/MerchantBranchAppointmentSettingsAddUpdate";
import AppointmentBookingList from "./views/appointments-bookings/AppointmentBookingList";
import AppointmentBookingAdd from "./views/appointments-bookings/AppointmentBookingAddUpdate";
import MerchantBranchPhotoAddUpdate from "./views/merchants-branches-photos/MerchantBranchPhotosAddUpdate";
import MerchantBranchPhotosList from "./views/merchants-branches-photos/MerchantBranchPhotosList";
import MerchantBranchRatingsList from "./views/merchants-branches-ratings/MerchantBranchRatingsList";
import OfferList from "./views/offers/OfferList";
import OfferAddUpdate from "./views/offers/OfferAddUpdate";
import { Memory } from "./core/Memory";
import { Scopes } from "./shared/scopes.enum";
import CityAreaList from "./views/city-area/CityAreaList";
import CityAreaAddUpdate from "./views/city-area/CityAreaAddUpdate";
import MerchantItemList from "./views/merchants-items/MerchantItemList";
import MerchantSubItemList from "./views/merchants-sub-items/MerchantSubItemList";
import MerchantSubItemAddUpdate from "./views/merchants-sub-items/MerchantSubItemAddUpdate";
import MerchantItemAddUpdate from "./views/merchants-items/MerchantItemAddUpdate";
import MerchantjobList from "./views/merchants-jobs/MerchantjobList";
import MerchantWorkerList from "./views/merchants-workers/MerchantWorkerList";
import MerchantWorkerAddUpdate from "./views/merchants-workers/MerchantWorkerAddUpdate";
import MerchantUserList from "./views/merchants-users/MerchantUserList";
import MerchantUserAddUpdate from "./views/merchants-users/MerchantUserAddUpdate";
import MerchantBranchList from "./views/merchants-branches/MerchantBranchList";
import MerchantBranchAddUpdate from "./views/merchants-branches/MerchantBranchAddUpdate";
import MerchantJobAddUpdate from "./views/merchants-jobs/MerchantJobAddUpdate";
import MerchantBranchAppointmentsAddUpdate from "./views/merchants-branches-appointments/MerchantBranchAppointmentsAddUpdate";
import MerchantAppointmentsList from "./views/merchants-branches-appointments/MerchantAppointmentsList";
import MerchantBranchServiceDetailList from "./views/merchants-branches-service-details/MerchantBranchServiceDetailList";
import MerchantBranchServiceDetailAddUpdate from "./views/merchants-branches-service-details/MerchantBranchServiceDetailAddUpdate";
import WorkOrderList from "./views/work-orders/WorkOrderList";
import JobCardList from "./views/job-cards/JobCardList";
import JobCardAdd from "./views/job-cards/JobCardAdd";
import GarageDashboard from "./views/dashboard/GarageDashboard";
import WorkOrderManage from "./views/work-orders/WorkOrderManage";
import AppNotificationList from "./views/app-notifications/AppNotificationList";
import RoleList from "./views/roles/RoleList";
import UserAccessList from "./views/user-access/UserAccessList";
import PaymentMethodList from "./views/payment-methods/PaymentMethodList";
import GarageSetupList from "./views/garage-setup/GarageSetupList";
import CurrencyList from "./views/currencies/CurrencyList";
import DeliveryMethodList from "./views/delivery-methods/DeliveryMethodList";
import VehicleSpecList from "./views/vehicle-specs/VehicleSpecList";

const checklang = Memory.getItem("lang");

if (checklang) {
  strings.setLanguage(checklang);
} else {
  strings.setLanguage("fr");
  Memory.setItem("lang", "fr");
}
let routes = [
  {
    path: "/dashboard",
    name: strings.dashboard,
    menu: true,
    allow: [
      Scopes.MERCHANTS_BRANCHES_READ,
      Scopes.MERCHANTS_BRANCHES_WRITE,
      Scopes.WORK_ORDERS_READ,
    ],
    component: GarageDashboard,
    icon: "nc-icon nc-chart-bar-32",
    layout: "/admin",
  },

  {
    name: strings.cities_management,
    menu: true,
    allow: [Scopes.CITIES_READ],
    icon: "nc-icon nc-pin-3",
    layout: "/admin",
    collapse: true,
    state: "citiesManagement",
    views: [
      {
        path: "/cities",
        name: strings.city_list,
        menu: true,
        allow: [Scopes.CITIES_READ, Scopes.CITIES_WRITE],
        component: CityList,
        icon: "nc-icon nc-globe",
        layout: "/admin",
      },
      {
        path: "/areas",
        name: strings.city_areas,
        menu: true,
        allow: [Scopes.CITIES_READ, Scopes.CITIES_WRITE],
        component: CityAreaList,
        icon: "nc-icon nc-map-big",
        layout: "/admin",
      },
    ],
  },

  {
    name: strings.merchants_management,
    // hidden from the navigator: its screens are reached from a garage
    menu: false,
    allow: [
      Scopes.MERCHANTS_READ,
      Scopes.MERCHANTS_WRITE,
      Scopes.MERCHANTS_ITEMS_READ,
      Scopes.MERCHANTS_ITEMS_WRITE,
      Scopes.MERCHANTS_SUBITEMS_READ,
      Scopes.MERCHANTS_SUBITEMS_WRITE,
      Scopes.MERCHANTS_JOBS_READ,
      Scopes.MERCHANTS_JOBS_WRITE,
      Scopes.MERCHANTS_WORKERS_READ,
      Scopes.MERCHANTS_WORKERS_WRITE,
      Scopes.MERCHANTS_USERS_READ,
      Scopes.MERCHANTS_USERS_WRITE,
    ],
    icon: "nc-icon nc-briefcase-24",
    layout: "/admin",
    collapse: true,
    state: "merchantsManagement",
    views: [
      {
        path: "/merchants",
        name: strings.merchant,
        menu: true,
        allow: [Scopes.MERCHANTS_READ, Scopes.MERCHANTS_WRITE],
        component: MerchantList,
        icon: "nc-icon nc-shop",
        layout: "/admin",
      },
      {
        path: "/merchant/:selectedMerchant/items",
        name: strings.merchant_items,
        menu: true,
        allow: [Scopes.MERCHANTS_ITEMS_READ, Scopes.MERCHANTS_ITEMS_WRITE],
        component: MerchantItemList,
        icon: "nc-icon nc-box",
        layout: "/admin",
      },
      {
        path: "/merchant/:selectedItem/subitems",
        name: strings.merchant_subitems,
        component: MerchantSubItemList,
        allow: [
          Scopes.MERCHANTS_SUBITEMS_WRITE,
          Scopes.MERCHANTS_SUBITEMS_WRITE,
        ],

        icon: "nc-icon nc-tile-56",
        layout: "/admin",
        menu: true,
      },
      {
        path: "/merchant/:selectedMerchant/jobs",
        name: strings.merchant_jobs,
        menu: true,
        allow: [Scopes.MERCHANTS_JOBS_READ, Scopes.MERCHANTS_JOBS_WRITE],
        component: MerchantjobList,
        icon: "nc-icon nc-briefcase-24",
        layout: "/admin",
      },

      {
        path: "/merchant/:selectedMerchant/worker",
        name: strings.merchant_workers,
        menu: true,
        allow: [Scopes.MERCHANTS_WORKERS_READ, Scopes.MERCHANTS_WORKERS_WRITE],
        component: MerchantWorkerList,
        icon: "nc-icon nc-single-02",
        layout: "/admin",
      },
      {
        path: "/merchant/:selectedMerchant/users",
        name: strings.merchant_users,
        // hidden from the navigator: reached from a garage's own "Users"
        // section (see garage-sections.js), not as its own top-level entry
        menu: false,
        allow: [Scopes.MERCHANTS_USERS_READ, Scopes.MERCHANTS_USERS_WRITE],
        component: MerchantUserList,
        icon: "nc-icon nc-circle-10",
        layout: "/admin",
      },
    ],
  },

  {
    path: "/merchant/:selectedMerchant/branches",
    name: strings.garages,
    menu: true,
    // a garage login has exactly one garage: TopNav skips this list for it
    // and shows that garage's sections directly instead
    hideForGarageLogin: true,
    allow: [Scopes.MERCHANTS_BRANCHES_READ, Scopes.MERCHANTS_BRANCHES_WRITE],
    component: MerchantBranchList,
    icon: "nc-icon nc-bank",
    layout: "/admin",
  },

  // Garage sections: opened from a garage record, not from the sidebar.
  {
    path: "/merchants-branches/:selectedBranch/services",
    name: strings.branch_services,
    menu: false,
    redirect: true,
    allow: [
      Scopes.MERCHANTS_BRANCHES_SERVICES_READ,
      Scopes.MERCHANTS_BRANCHES_SERVICES_WRITE,
    ],
    component: MerchantBranchServiceList,
    icon: "nc-icon nc-settings",
    layout: "/admin",
  },
  {
    path: "/merchant-branch/:selectedBranch/photos",
    name: strings.branch_photos,
    menu: false,
    redirect: true,
    allow: [
      Scopes.MERCHANTS_BRANCHES_PHOTOS_READ,
      Scopes.MERCHANTS_BRANCHES_PHOTOS_WRITE,
    ],
    component: MerchantBranchPhotosList,
    icon: "nc-icon nc-album-2",
    layout: "/admin",
  },
  {
    path: "/merchants-branches/:selectedBranch/ratings",
    name: strings.branch_ratings,
    menu: false,
    redirect: true,
    allow: [
      Scopes.MERCHANTS_BRANCHES_RATINGS_READ,
      Scopes.MERCHANTS_BRANCHES_RATINGS_WRITE,
    ],
    component: MerchantBranchRatingsList,
    icon: "nc-icon nc-favourite-28",
    layout: "/admin",
  },
  {
    path: "/merchants-branches/:selectedBranch/workers",
    name: strings.merchant_workers,
    menu: false,
    redirect: true,
    allow: [Scopes.MERCHANTS_WORKERS_READ, Scopes.MERCHANTS_WORKERS_WRITE],
    component: MerchantWorkerList,
    icon: "nc-icon nc-single-02",
    layout: "/admin",
  },
  {
    path: "/merchants-branches/:selectedBranch/garage-setup",
    name: strings.garage_setup,
    menu: false,
    redirect: true,
    allow: [Scopes.GARAGE_SETUP_READ, Scopes.GARAGE_SETUP_WRITE],
    component: GarageSetupList,
    icon: "nc-icon nc-money-coins",
    layout: "/admin",
  },
  {
    path: "/merchants-branches/:selectedBranch/users",
    name: strings.merchant_users,
    menu: false,
    redirect: true,
    allow: [Scopes.MERCHANTS_USERS_READ, Scopes.MERCHANTS_USERS_WRITE],
    component: MerchantUserList,
    icon: "nc-icon nc-circle-10",
    layout: "/admin",
  },
  {
    path: "/merchants-branches/:selectedBranch/job-cards/new/:bookingId",
    name: strings.new_job_card,
    menu: false,
    redirect: true,
    allow: [Scopes.WORK_ORDERS_WRITE],
    component: JobCardAdd,
    icon: "nc-icon nc-paper",
    layout: "/admin",
  },
  {
    path: "/merchants-branches/:selectedBranch/job-cards",
    name: strings.job_cards,
    menu: false,
    redirect: true,
    allow: [Scopes.WORK_ORDERS_READ, Scopes.WORK_ORDERS_WRITE],
    component: JobCardList,
    icon: "nc-icon nc-paper",
    layout: "/admin",
  },
  {
    path: "/merchants-branches/:selectedBranch/work-orders",
    name: strings.work_orders,
    menu: false,
    redirect: true,
    allow: [Scopes.WORK_ORDERS_READ, Scopes.WORK_ORDERS_WRITE],
    component: WorkOrderList,
    icon: "nc-icon nc-settings-tool-66",
    layout: "/admin",
  },
  {
    path: "/merchants-branches/:selectedBranch/services/:selectedService/details",
    name: strings.branch_service_details,
    menu: false,
    redirect: true,
    allow: [
      Scopes.MERCHANTS_BRANCHES_SERVICES_READ,
      Scopes.MERCHANTS_BRANCHES_SERVICES_WRITE,
    ],
    component: MerchantBranchServiceDetailList,
    icon: "nc-icon nc-bullet-list-67",
    layout: "/admin",
  },

  {
    name: strings.appointments_management,
    // hidden from the navigator: appointments and their settings are reached
    // from a garage, and bookings from an appointment
    menu: false,
    allow: [
      Scopes.MERCHANTS_BRANCHES_APPOINTMENTS_READ,
      Scopes.MERCHANTS_BRANCHES_APPOINTMENTS_WRITE,
      Scopes.MERCHANTS_BRANCHES_APPOINTMENTS_SETTINGS_READ,
      Scopes.MERCHANTS_BRANCHES_APPOINTMENTS_SETTINGS_WRITE,
      Scopes.MERCHANTS_BRANCHES_APPOINTMENTS_BOOKINGS_READ,
      Scopes.MERCHANTS_BRANCHES_APPOINTMENTS_BOOKINGS_WRITE,
    ],
    icon: "nc-icon nc-calendar-60",
    layout: "/admin",
    collapse: true,
    state: "appointmentsManagement",
    views: [
      {
        path: "/merchants-branches/:selectedBranch/appointments-settings",
        name: strings.appointment_settings,
        menu: true,
        allow: [
          Scopes.MERCHANTS_BRANCHES_APPOINTMENTS_SETTINGS_READ,
          Scopes.MERCHANTS_BRANCHES_APPOINTMENTS_SETTINGS_WRITE,
        ],
        component: MerchantBranchAppointmentSettingsList,
        icon: "nc-icon nc-settings-gear-65",
        layout: "/admin",
      },
      {
        path: "/merchants-branches/:selectedBranch/appointments",
        name: strings.appointments,
        menu: true,
        allow: [
          Scopes.MERCHANTS_BRANCHES_APPOINTMENTS_READ,
          Scopes.MERCHANTS_BRANCHES_APPOINTMENTS_WRITE,
        ],
        component: MerchantAppointmentsList,
        icon: "nc-icon nc-calendar-60",
        layout: "/admin",
      },
      {
        path: "/merchants-branches/:selectedAppointment/appointment-booking",
        name: strings.appointment_bookings,
        menu: true,
        allow: [
          Scopes.MERCHANTS_BRANCHES_APPOINTMENTS_BOOKINGS_READ,
          Scopes.MERCHANTS_BRANCHES_APPOINTMENTS_BOOKINGS_WRITE,
        ],
        component: AppointmentBookingList,
        icon: "nc-icon nc-paper",
        layout: "/admin",
      },
    ],
  },

  {
    name: strings.setup,
    menu: true,
    allow: [
      Scopes.SERVICES_READ,
      Scopes.SERVICES_WRITE,
      Scopes.MERCHANTS_BRANCHES_OFFERS_READ,
      Scopes.MERCHANTS_BRANCHES_OFFERS_WRITE,
      Scopes.VEHICLES_MAKES_READ,
      Scopes.VEHICLES_MAKES_WRITE,
      Scopes.PAYMENT_METHODS_READ,
      Scopes.PAYMENT_METHODS_WRITE,
      Scopes.CURRENCIES_READ,
      Scopes.CURRENCIES_WRITE,
      Scopes.DELIVERY_METHODS_READ,
      Scopes.DELIVERY_METHODS_WRITE,
      // Application Setup lives in here, so its permissions have to open the
      // dropdown too or it would be unreachable for an account that holds
      // nothing else in this group
      Scopes.CITIES_WRITE,
      Scopes.MERCHANTS_WRITE_ALL,
    ],
    icon: "nc-icon nc-settings-gear-65",
    layout: "/admin",
    collapse: true,
    state: "setup",
    views: [
      {
        path: "/services",
        name: strings.services,
        menu: true,
        allow: [Scopes.SERVICES_READ, Scopes.SERVICES_WRITE],
        component: ServiceList,
        icon: "nc-icon nc-settings",
        layout: "/admin",
      },
      {
        path: "/offers",
        name: strings.offers,
        menu: true,
        allow: [
          Scopes.MERCHANTS_BRANCHES_OFFERS_READ,
          Scopes.MERCHANTS_BRANCHES_OFFERS_WRITE,
        ],
        component: OfferList,
        icon: "nc-icon nc-badge",
        layout: "/admin",
      },
      {
        path: "/vehicles",
        name: strings.vehicles,
        menu: true,
        allow: [Scopes.VEHICLES_MAKES_READ, Scopes.VEHICLES_MAKES_WRITE],
        component: VehicleMakeList,
        icon: "nc-icon nc-delivery-fast",
        layout: "/admin",
      },
      {
        // the specs a client picks from when adding a car — vehicle catalogue
        // data, so it shares the Vehicles permissions
        path: "/vehicle-specs",
        name: strings.vehicle_specs,
        menu: true,
        allow: [Scopes.VEHICLES_MAKES_READ, Scopes.VEHICLES_MAKES_WRITE],
        component: VehicleSpecList,
        icon: "nc-icon nc-tag-content",
        layout: "/admin",
      },
      {
        path: "/payment-methods",
        name: strings.payment_methods,
        menu: true,
        allow: [Scopes.PAYMENT_METHODS_READ, Scopes.PAYMENT_METHODS_WRITE],
        component: PaymentMethodList,
        icon: "nc-icon nc-credit-card",
        layout: "/admin",
      },
      {
        path: "/currencies",
        name: strings.currencies,
        menu: true,
        allow: [Scopes.CURRENCIES_READ, Scopes.CURRENCIES_WRITE],
        component: CurrencyList,
        icon: "nc-icon nc-money-coins",
        layout: "/admin",
      },
      {
        // how a car arrives and leaves; the job card picks from it
        path: "/delivery-methods",
        name: strings.delivery_methods,
        menu: true,
        allow: [
          Scopes.DELIVERY_METHODS_READ,
          Scopes.DELIVERY_METHODS_WRITE,
        ],
        component: DeliveryMethodList,
        icon: "nc-icon nc-delivery-fast",
        layout: "/admin",
      },
      {
        path: "/application-setup",
        name: strings.application_setup,
        menu: true,
        allow: [Scopes.CITIES_WRITE, Scopes.MERCHANTS_WRITE_ALL],
        component: ApplicationSetup,
        icon: "nc-icon nc-settings-gear-65",
        layout: "/admin",
      },
    ],
  },

  {
    name: strings.vehicles_management,
    // hidden from the navigator: models and trims are reached by drilling
    // into a vehicle from Setup > Vehicles
    menu: false,
    allow: [Scopes.VEHICLES_MAKES_READ, Scopes.VEHICLES_MAKES_WRITE],
    icon: "nc-icon nc-bus-front-12",
    layout: "/admin",
    collapse: true,
    state: "vehiclesManagement",
    views: [
      {
        path: "/vehicles_models/:selectedMake",
        name: strings.vehicle_models,
        menu: true,
        allow: [Scopes.VEHICLES_MAKES_READ, Scopes.VEHICLES_MAKES_WRITE],
        component: VehicleModelList,
        icon: "nc-icon nc-layout-11",
        layout: "/admin",
      },
      {
        path: "/vehicles_models/:selectedModel/trims",
        name: strings.vehicle_model_trims,
        menu: true,
        allow: [Scopes.VEHICLES_MAKES_READ, Scopes.VEHICLES_MAKES_WRITE],
        component: VehicleModelTrimsList,
        icon: "nc-icon nc-tile-56",
        layout: "/admin",
      },
    ],
  },

  {
    name: strings.banners,
    menu: true,
    allow: [
      Scopes.NOTIFICATIONS_READ,
      Scopes.NOTIFICATIONS_WRITE,
      Scopes.BANNERS_READ,
      Scopes.BANNERS_WRITE,
    ],
    icon: "nc-icon nc-bell-55",
    layout: "/admin",
    collapse: true,
    state: "notificationsBanners",
    views: [
      {
        path: "/Notifications",
        name: strings.notifications,
        menu: true,
        allow: [Scopes.NOTIFICATIONS_READ, Scopes.NOTIFICATIONS_WRITE],
        component: NotificationList,
        icon: "nc-icon nc-bell-55",
        layout: "/admin",
      },
      {
        path: "/Banners",
        name: strings.banners,
        menu: true,
        allow: [Scopes.BANNERS_READ, Scopes.BANNERS_WRITE],
        component: BannerList,
        icon: "nc-icon nc-album-2",
        layout: "/admin",
      },
    ],
  },

  {
    name: strings.users_management,
    menu: true,
    // a garage login gets none of this dropdown except the customer list,
    // shown as a flat "Customers" link — see TopNav.applyGarageLoginNav
    allow: [
      Scopes.USERS_READ,
      Scopes.USERS_WRITE,
      Scopes.MERCHANTS_USERS_READ,
      Scopes.MERCHANTS_USERS_WRITE,
      Scopes.CUSTOMERS_USERS_READ,
      Scopes.CUSTOMERS_USERS_WRITE,
      Scopes.CUSTOMERS_VEHICLES_READ,
      Scopes.CUSTOMERS_VEHICLES_WRITE,
    ],
    icon: "nc-icon nc-single-02",
    layout: "/admin",
    collapse: true,
    state: "usersManagement",
    views: [
      {
        path: "/users",
        name: strings.user_list,
        menu: true,
        allow: [Scopes.USERS_READ, Scopes.USERS_WRITE],
        component: UserList,
        icon: "nc-icon nc-paper",
        layout: "/admin",
      },
      {
        path: "/roles",
        name: strings.roles,
        menu: true,
        // users:* is not part of any merchant scope ceiling, so it can never be
        // granted; access management rides on merchants-users:* instead
        allow: [
          Scopes.MERCHANTS_USERS_READ,
          Scopes.MERCHANTS_USERS_WRITE,
          Scopes.USERS_READ,
          Scopes.USERS_WRITE,
        ],
        component: RoleList,
        icon: "nc-icon nc-badge",
        layout: "/admin",
      },
      {
        path: "/user-access",
        name: strings.user_access,
        menu: true,
        allow: [Scopes.MERCHANTS_USERS_READ, Scopes.MERCHANTS_USERS_WRITE],
        component: UserAccessList,
        icon: "nc-icon nc-key-25",
        layout: "/admin",
      },
      {
        path: "/customer_user/:selectedMerchant/users",
        name: strings.customer_users,
        menu: true,
        allow: [Scopes.CUSTOMERS_USERS_READ, Scopes.CUSTOMERS_USERS_WRITE],
        component: CustomerUserList,
        icon: "nc-icon nc-circle-10",
        layout: "/admin",
      },
      {
        path: "/customer_vehicles/:selectedCustomer",
        name: strings.customer_vehicles,
        menu: true,
        allow: [
          Scopes.CUSTOMERS_VEHICLES_READ,
          Scopes.CUSTOMERS_VEHICLES_WRITE,
        ],
        component: CustomerVehiclesList,
        icon: "nc-icon nc-bus-front-12",
        layout: "/admin",
      },
    ],
  },

  {
    path: "/cities/add",
    name: strings.add_city,
    menu: false,
    redirect: true,
    allow: [Scopes.CITIES_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: CityAddUpdate,
    layout: "/admin",
  },
  {
    path: "/cities/edit/:id",
    name: strings.edit_client,
    menu: false,
    redirect: true,

    allow: [Scopes.CITIES_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: CityAddUpdate,
    layout: "/admin",
  },
  {
    path: "/merchants/add",
    name: strings.add_merchant,
    menu: false,
    redirect: true,

    allow: [Scopes.MERCHANTS_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: MerchantAddUpdate,
    layout: "/admin",
  },
  {
    path: "/merchants/edit/:id",
    name: strings.edit_merchant,
    menu: false,
    redirect: true,

    allow: [Scopes.MERCHANTS_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: MerchantAddUpdate,
    layout: "/admin",
  },
  {
    path: "/offers/add",
    name: strings.add_offer,
    menu: false,
    redirect: true,

    allow: [Scopes.OFFERS_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: OfferAddUpdate,
    layout: "/admin",
  },
  {
    path: "/offers/edit/:id",
    name: strings.edit_offer,
    menu: false,
    redirect: true,

    allow: [Scopes.OFFERS_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: OfferAddUpdate,
    layout: "/admin",
  },
  {
    path: "/merchant/:selectedMerchant/items/add",
    name: strings.add_merchant_items,
    menu: false,
    redirect: true,

    allow: [Scopes.MERCHANTS_ITEMS_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: MerchantItemAddUpdate,
    layout: "/admin",
  },
  {
    path: "/merchant/:selectedMerchant/items/edit/:id",
    name: strings.edit_merchant_items,
    menu: false,
    redirect: true,

    allow: [Scopes.MERCHANTS_ITEMS_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: MerchantItemAddUpdate,
    layout: "/admin",
  },
  {
    path: "/merchant/:selectedItem/subitems/add",
    name: strings.add_merchant_subitems,
    menu: false,
    redirect: true,

    allow: [Scopes.MERCHANTS_ITEMS_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: MerchantSubItemAddUpdate,
    layout: "/admin",
  },
  {
    path: "/merchant/:selectedItem/subitems/edit/:id",
    name: strings.edit_merchant_subitems,
    menu: false,
    redirect: true,

    allow: [Scopes.MERCHANTS_ITEMS_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: MerchantSubItemAddUpdate,
    layout: "/admin",
  },
  {
    path: "/merchant/:selectedMerchant/jobs/add",
    name: strings.add_merchant_jobs,
    menu: false,
    redirect: true,

    allow: [Scopes.MERCHANTS_JOBS_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: MerchantJobAddUpdate,
    layout: "/admin",
  },
  {
    path: "/merchant/:selectedMerchant/jobs/edit/:id",
    name: strings.edit_merchant_jobs,
    menu: false,
    redirect: true,

    allow: [Scopes.MERCHANTS_JOBS_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: MerchantJobAddUpdate,
    layout: "/admin",
  },
  {
    path: "/merchants-branches/:selectedBranch/services/add",
    name: strings.add_merchant_branch_service,
    menu: false,
    redirect: true,

    allow: [Scopes.MERCHANTS_BRANCHES_SERVICES_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: MerchantBranchServiceAddUpdate,
    layout: "/admin",
  },
  {
    path: "/merchants-branches/:selectedBranch/services/edit/:id",
    name: strings.edit_merchant_branch_service,
    menu: false,
    redirect: true,

    allow: [Scopes.MERCHANTS_BRANCHES_SERVICES_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: MerchantBranchServiceAddUpdate,
    layout: "/admin",
  },
  {
    path: "/merchant-branch/:selectedBranch/photos/add",
    name: strings.add_merchant_branch_photo,
    menu: false,
    redirect: true,

    allow: [Scopes.MERCHANTS_BRANCHES_PHOTOS_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: MerchantBranchPhotoAddUpdate,
    layout: "/admin",
  },
  {
    path: "/merchant-branch/:selectedBranch/photos/edit/:id",
    name: strings.edit_merchant_branch_photo,
    menu: false,
    redirect: true,

    allow: [Scopes.MERCHANTS_BRANCHES_PHOTOS_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: MerchantBranchPhotoAddUpdate,
    layout: "/admin",
  },
  {
    path: "/merchants-branches/:selectedBranch/appointments-settings/add",
    name: strings.add_merchant_branch_appointment_settings,
    menu: false,
    redirect: true,

    allow: [Scopes.MERCHANTS_BRANCHES_APPOINTMENTS_SETTINGS_WRITE],
    component: MerchantBranchAppointmentSettingsAddUpdate,
    icon: "nc-icon nc-paper",
    layout: "/admin",
  },
  {
    path: "/merchants-branches/:selectedBranch/appointments-settings/edit/:id",
    name: strings.edit_merchant_branch_appointment_settings,
    menu: false,
    redirect: true,

    allow: [Scopes.MERCHANTS_BRANCHES_APPOINTMENTS_SETTINGS_WRITE],
    component: MerchantBranchAppointmentSettingsAddUpdate,
    icon: "nc-icon nc-paper",
    layout: "/admin",
  },
  {
    path: "/merchants-branches/:appointment/appointment-booking/add",
    name: strings.add_appointment_booking,
    menu: false,
    redirect: true,

    allow: [Scopes.MERCHANTS_BRANCHES_APPOINTMENTS_BOOKINGS_WRITE],
    component: AppointmentBookingAdd,
    icon: "nc-icon nc-paper",
    layout: "/admin",
  },
  {
    path: "/merchants-branches/:appointment/appointment-booking/edit/:id",
    name: strings.edit_appointment_booking,
    menu: false,
    redirect: true,

    allow: [Scopes.MERCHANTS_BRANCHES_APPOINTMENTS_BOOKINGS_WRITE],
    component: AppointmentBookingAdd,
    icon: "nc-icon nc-paper",
    layout: "/admin",
  },
  {
    path: "/merchants-branches/:selectedBranch/appointments/add",
    name: strings.add_merchant_branch_service,
    menu: false,
    redirect: true,

    allow: [Scopes.MERCHANTS_BRANCHES_APPOINTMENTS_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: MerchantBranchAppointmentsAddUpdate,
    layout: "/admin",
  },
  {
    path: "/merchants-branches/:selectedBranch/appointments/edit/:id",
    name: strings.edit_merchant_branch_service,
    menu: false,
    redirect: true,

    allow: [Scopes.MERCHANTS_BRANCHES_APPOINTMENTS_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: MerchantBranchAppointmentsAddUpdate,
    layout: "/admin",
  },
  {
    path: "/merchants-branches/:selectedBranch/services/:selectedService/details/add",
    name: strings.add_service_detail,
    menu: false,
    redirect: true,
    allow: [Scopes.MERCHANTS_BRANCHES_SERVICES_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: MerchantBranchServiceDetailAddUpdate,
    layout: "/admin",
  },
  {
    path: "/merchants-branches/:selectedBranch/services/:selectedService/details/edit/:id",
    name: strings.edit_service_detail,
    menu: false,
    redirect: true,
    allow: [Scopes.MERCHANTS_BRANCHES_SERVICES_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: MerchantBranchServiceDetailAddUpdate,
    layout: "/admin",
  },
  {
    path: "/vehicles/add",
    name: strings.add_vehicles_make,
    menu: false,
    redirect: true,

    allow: [Scopes.VEHICLES_MAKES_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: VehicleMakeAddUpdate,
    layout: "/admin",
  },
  {
    path: "/vehicles/edit/:id",
    name: strings.edit_vehicles_make,
    menu: false,
    redirect: true,

    allow: [Scopes.VEHICLES_MAKES_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: VehicleMakeAddUpdate,
    layout: "/admin",
  },
  {
    path: "/vehicles_models/:selectedMake/add",
    name: strings.add_vehicle_model,
    menu: false,
    redirect: true,

    allow: [Scopes.VEHICLES_MAKES_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: VehicleModelAddUpdate,
    layout: "/admin",
  },
  {
    path: "/vehicles_models/:selectedMake/edit/:id",
    name: strings.edit_vehicle_model,
    menu: false,
    redirect: true,

    allow: [Scopes.VEHICLES_MAKES_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: VehicleModelAddUpdate,
    layout: "/admin",
  },
  {
    path: "/vehicles_models/:selectedModel/trims/add",
    name: strings.add_vehicle_model_trim,
    menu: false,
    redirect: true,

    allow: [Scopes.VEHICLES_MAKES_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: VehicleModelTrimsAddUpdate,
    layout: "/admin",
  },
  {
    path: "/vehicles_models/:selectedModel/trims/edit/:id",
    name: strings.edit_vehicle_model_trim,
    menu: false,
    redirect: true,

    allow: [Scopes.VEHICLES_MAKES_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: VehicleModelTrimsAddUpdate,
    layout: "/admin",
  },
  {
    path: "/Notifications/add",
    name: strings.add_notifications,
    menu: false,
    redirect: true,

    allow: [Scopes.NOTIFICATIONS_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: NotificationAddUpdate,
    layout: "/admin",
  },
  {
    path: "/Notifications/edit/:id",
    name: strings.edit_notifications,
    menu: false,
    redirect: true,

    allow: [Scopes.NOTIFICATIONS_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: NotificationAddUpdate,
    layout: "/admin",
  },
  {
    path: "/services/add",
    name: strings.add_services,
    menu: false,
    redirect: true,

    allow: [Scopes.SERVICES_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: ServiceAddUpdate,
    layout: "/admin",
  },
  {
    path: "/services/edit/:id",
    name: strings.edit_services,
    menu: false,
    redirect: true,

    allow: [Scopes.SERVICES_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: ServiceAddUpdate,
    layout: "/admin",
  },
  {
    path: "/areas/add",
    name: strings.add_areas,
    menu: false,
    redirect: true,

    allow: [Scopes.CITIES_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: CityAreaAddUpdate,
    layout: "/admin",
  },
  {
    path: "/areas/edit/:id",
    name: strings.edit_areas,
    menu: false,
    redirect: true,

    allow: [Scopes.CITIES_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: CityAreaAddUpdate,
    layout: "/admin",
  },

  {
    path: "/Banners/add",
    name: strings.add_banner,
    menu: false,
    redirect: true,

    allow: [Scopes.BANNERS_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: BannerAddUpdate,
    layout: "/admin",
  },
  {
    path: "/Banners/edit/:id",
    name: strings.edit_banner,
    menu: false,
    redirect: true,

    allow: [Scopes.BANNERS_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: BannerAddUpdate,
    layout: "/admin",
  },
  {
    path: "/users/edit/:id",
    name: strings.edit_user,
    menu: false,
    redirect: true,

    allow: [Scopes.USERS_WRITE],
    component: UserAddUpdate,
    icon: "nc-icon nc-paper",
    layout: "/admin",
  },
  {
    path: "/users/add",
    name: strings.add_user,
    menu: false,
    redirect: true,

    allow: [Scopes.USERS_WRITE],
    component: UserAddUpdate,
    icon: "nc-icon nc-paper",
    layout: "/admin",
  },
  {
    path: "/customer_vehicles/:selectedCustomer/add",
    name: strings.add_vehicle,
    menu: false,
    redirect: true,

    allow: [Scopes.CUSTOMERS_VEHICLES_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: CustomerVehiclesAddUpdate,
    layout: "/admin",
  },
  {
    path: "/customer_vehicles/:selectedCustomer/edit/:id",
    name: strings.edit_vehicle,
    menu: false,
    redirect: true,

    allow: [Scopes.CUSTOMERS_VEHICLES_WRITE],
    component: CustomerVehiclesAddUpdate,
    icon: "nc-icon nc-paper",
    layout: "/admin",
  },
  {
    path: "/customer_user/:selectedMerchant/edit/:id",
    name: strings.edit_vehicle,
    menu: false,
    redirect: true,

    allow: [Scopes.CUSTOMERS_USERS_WRITE],
    component: CustomerUserAddUpdate,
    icon: "nc-icon nc-paper",
    layout: "/admin",
  },
  {
    path: "/customer_user/:selectedMerchant/add",
    name: strings.add_vehicle,
    menu: false,
    redirect: true,

    allow: [Scopes.CUSTOMERS_USERS_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: CustomerUserAddUpdate,
    layout: "/admin",
  },
  {
    path: "/merchant/:selectedMerchant/branches/edit/:id",
    name: strings.edit_merchantbranch,
    menu: false,
    redirect: true,

    allow: [Scopes.MERCHANTS_BRANCHES_WRITE],
    component: MerchantBranchAddUpdate,
    icon: "nc-icon nc-paper",
    layout: "/admin",
  },

  {
    path: "/merchant/:selectedMerchant/branches/add",
    name: strings.add_merchantbranch,
    menu: false,
    redirect: true,

    allow: [Scopes.MERCHANTS_BRANCHES_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: MerchantBranchAddUpdate,
    layout: "/admin",
  },
  {
    path: "/merchant/:selectedMerchant/workers/edit/:id",
    name: strings.edit_merchantworker,
    menu: false,
    redirect: true,

    allow: [Scopes.MERCHANTS_WORKERS_WRITE],
    component: MerchantWorkerAddUpdate,
    icon: "nc-icon nc-paper",
    layout: "/admin",
  },

  {
    path: "/merchant/:selectedMerchant/workers/add",
    name: strings.add_merchantworker,
    menu: false,
    redirect: true,

    allow: [Scopes.MERCHANTS_WORKERS_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: MerchantWorkerAddUpdate,
    layout: "/admin",
  },
  {
    path: "/merchant/:selectedMerchant/users/edit/:id",
    name: strings.edit_merchantuser,
    menu: false,
    redirect: true,

    allow: [Scopes.MERCHANTS_USERS_WRITE],
    component: MerchantUserAddUpdate,
    icon: "nc-icon nc-paper",
    layout: "/admin",
  },

  {
    path: "/merchant/:selectedMerchant/users/add",
    name: strings.add_merchantuser,
    menu: false,
    redirect: true,

    allow: [Scopes.MERCHANTS_USERS_WRITE],
    icon: "nc-icon nc-settings-gear-65",
    component: MerchantUserAddUpdate,
    layout: "/admin",
  },
  {
    path: "/login",
    name: strings.login,
    mini: "L",
    menu: false,
    redirect: true,

    component: Login,
    layout: "/auth",
  },

  // Notifications Feed - menu entry
  {
    path: "/app-notifications",
    name: strings.notifications_feed,
    menu: true,
    allow: [Scopes.WORK_ORDERS_READ, Scopes.WORK_ORDERS_WRITE],
    component: AppNotificationList,
    icon: "nc-icon nc-bell-55",
    layout: "/admin",
  },

  // Work Order manage (no menu, navigated from list)
  {
    path: "/work-orders/:workOrderId/manage",
    name: "Manage Work Order",
    menu: false,
    redirect: true,
    allow: [
      Scopes.WORK_ORDERS_WRITE,
      Scopes.MERCHANTS_BRANCHES_APPOINTMENTS_BOOKINGS_WRITE,
    ],
    component: WorkOrderManage,
    layout: "/admin",
  },

  // Global application setup (super-admin)
];

export default routes;
